import { useMemo } from 'react';
import type { ISocialAccount } from '@components';
import { memberAudienceSummaryAdapter } from '@/app/containers/Projects/ProjectsPage/ProspectsList/adapters/member-audience-summary-adapter';

export interface AudienceSummaryData {
  engagementsPerPost: string;
  impressionsPerPost: string;
  audienceAuthenticity: string;
}

export interface AudienceSummarySectionProps {
  isLoading: boolean;
  data: AudienceSummaryData;
}

export const useAudienceSummaryProps = (
  isFetchingSocialData: boolean,
  socialData?: ISocialAccount | null
): AudienceSummarySectionProps => {
  const adaptedData = useMemo(() => {
    if (!socialData) {
      return {
        engagementsPerPost: '--',
        impressionsPerPost: '--',
        audienceAuthenticity: '--'
      };
    }
    return memberAudienceSummaryAdapter(socialData);
  }, [socialData]);

  return {
    isLoading: isFetchingSocialData,
    data: adaptedData
  };
};
